import { Color } from "capitalrx-components-2.0/lib/general";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold, TextColor } from "capitalrx-components-2.0/lib/typography";
import { ReactNode } from "react";

export const ClaimInfoStack = ({ title, body }: {title: string, body: ReactNode | string}) => {
  return (
    <Stack spacing="mini" alignment="left">
      <Semibold><TextColor appearance={Color.DarkGrey["400"]}>{title}</TextColor></Semibold>
      <Body>{body}</Body>
    </Stack>
  );
};
